import { connect } from 'react-redux'
import reloadApplication from '../../actions/synchronize/reloadApplication'
import getNewVersionModalIsOpen from '../../reducers/synchronize/selectors/getNewVersionModalIsOpen'
import getVersion from '../../reducers/synchronize/selectors/getVersion'
import NewVersionModal from './NewVersionModal'

const mapStateToProps = state => ({
  open: getNewVersionModalIsOpen(state),
  version: getVersion(state),
})

const mapDispatchToProps = (dispatch) => ({
  reloadApp: () => dispatch(reloadApplication()),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewVersionModal)
